
import { gql } from '@apollo/client';
import { FormField } from '~/components/screens/forms/components_forms_creator/types';

// Enums mapping para GraphQL
const TYPE_MAPPING: Record<string, string> = {
  'standard': 'STANDARD',
  'attribute': 'ATTRIBUTE', 
  'integration': 'INTEGRATION'
};

const INPUT_TYPE_MAPPING: Record<string, string> = {
  'text': 'TEXT',
  'select': 'SELECT',
  'checkbox': 'CHECKBOX',
  'email': 'EMAIL',
  'number': 'NUMBER',
  'date': 'DATE',
  'closelist': 'SELECT', // closelist se mapea a SELECT
  'openlist': 'SELECT', // openlist se mapea a SELECT
  'file': 'TEXT', // file inputs se manejan como TEXT por ahora
  'api': 'API'
};

const DATA_TYPE_MAPPING: Record<string, string> = {
  'text': 'TEXT',
  'number': 'NUMBER',
  'email': 'EMAIL',
  'boolean': 'BOOLEAN',
  'date': 'DATE',
  'closelist': 'CLOSELIST',
  'openlist': 'OPENLIST',
  'tel': 'TEL',
  'url': 'URL',
  'password': 'PASSWORD',
  'textarea': 'TEXTAREA',
  'datetime': 'DATETIME',
  'time': 'TIME'
};

const METHOD_MAPPING: Record<string, string> = {
  'GET': 'GET',
  'POST': 'POST', 
  'PUT': 'PUT',
  'DELETE': 'DELETE',
  'PATCH': 'PATCH'
};

const AUTH_TYPE_MAPPING: Record<string, string> = {
  'none': 'NONE',
  'bearer': 'BEARER',
  'basic': 'BASIC',
  'api-key': 'API_KEY'
};

const FORMAT_MAPPING: Record<string, string> = {
  'json': 'JSON',
  'xml': 'XML',
  'form-data': 'FORM_DATA',
  'text': 'TEXT'
};

// Helper function para mapear valores a enums GraphQL
export const mapToGraphQLEnums = (field: FormField) => {
  const mappedField = {
    ...field,
    type: TYPE_MAPPING[field.type] || field.type,
    inputType: INPUT_TYPE_MAPPING[field.inputType || ''] || field.inputType,
  };

  // Solo agregar dataType si existe en el campo original
  if (field.dataType) {
    mappedField.dataType = DATA_TYPE_MAPPING[field.dataType] || field.dataType;
  }

  // Para integraciones API, mapear también los valores del apiConfig si existen
  if (field.apiConfig) {
    mappedField.apiConfig = {
      ...field.apiConfig,
      method: METHOD_MAPPING[field.apiConfig.method || ''] || field.apiConfig.method,
      authType: AUTH_TYPE_MAPPING[field.apiConfig.authType || ''] || field.apiConfig.authType,
      format: FORMAT_MAPPING[field.apiConfig.format || ''] || field.apiConfig.format,
      // Asegurar que campos opcionales siempre sean strings vacíos si no tienen valor
      headers: field.apiConfig.headers || '',
      body: field.apiConfig.body || '',
      authToken: field.apiConfig.authToken || '',
      url: field.apiConfig.url || ''
    };
  }

  return mappedField;
};
 
export const CREATE_FORM = gql`
  mutation create_form($data: CreateFormInputType) {
    create_form(data: $data) {
        hasError
        data
        message
    }
}
`;

export const UPDATE_FORM = gql`
  mutation update_form($data: UpdateFormInputType) {
    update_form(data: $data) {
        hasError
        data
        message
    }
}
`;
 
export const LIST_FORMS = gql`
  query list_forms($data: ListFormsInputType) {
    list_forms(data: $data) {
        hasError
        data
        message
    }
}
`;
 
export const GET_FORM = gql`
  query get_form($data: GetFormInputType) {
    get_form(data: $data) {
        hasError
        data
        message
    }
}
`;
 